import React from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import { useModal } from "../../../Store/modules/modal/modal";
import { useLanguage } from "../../../Store/modules/language";
import { Div, Text } from "../../Kit";
import { Button } from "../../Kit/Button";
import { alert } from "../../../Utils/toast";
import { useThemeColors } from "../../../Store/modules/theme";
import { navigateToLocale } from "../../../Utils/navigateToLocale";

export const CopyLinkModal: React.FC = () => {
  const { modalProps } = useModal();
  const { unique_token } = modalProps || {};
  const [theme] = useThemeColors();
  const { locale } = useLanguage();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(`${host}/share/${unique_token}`)
      .then(() => alert({ message: "لینک کپی شد.", type: "success" }))
      .catch((err) => console.error("خطا در کپی:", err));
  };

  let host = window.location.origin;
  return (
    <Modal
      modalName={ModalNames.CopyLinkModal}
      showCloseIcon
      containerClassName="px-3"
      modalClassName="xs:w-[300px] md:w-[600px] rounded-[5px]"
    >
      <div className="text-start">
        <Text elementType="p" className="text-lg color-[#515151]" fontWeight={500}>
          result.share
        </Text>
        <Div
          bg="chatBox"
          className="flex flex-col mt-3 md:flex-row md:items-center border border-gray-300 rounded-lg px-3 py-2 max-w-2xl mx-auto space-y-4 md:space-y-0 md:space-x-4 rtl:space-x-reverse bg-[chatBox]"
        >
          <input
            className="text-blue-600 break-all text-center md:text-left md:flex-1 outline-none bg-transparent text-[13px]"
            dir="ltr"
            style={{ color: theme["text"] }}
            onFocus={(e) => e.target.select()}
            value={`${host}${navigateToLocale(locale)}share/${unique_token}`}
          />
          <Button
            title="result.copyLink"
            bg="primary"
            className="py-1.5 px-3 w-full md:w-auto transition text-[14px]"
            onClick={handleCopy}
          />
        </Div>
      </div>
    </Modal>
  );
};
